import { Modal, ModalBody, ModalHeader } from "flowbite-react";
import moment from "moment";
import {
  HiCheckCircle,
  HiExclamationCircle,
  HiXCircle,
  HiClock,
} from "react-icons/hi";

const actionLabels = {
  CREATED: {
    label: "Criado",
    icon: <HiClock className="text-gray-400" />,
    color: "bg-blue-100",
  },
  SEND: {
    label: "Enviado",
    icon: <HiCheckCircle className="text-green-500" />,
    color: "bg-green-100",
  },
  CANCEL: {
    label: "Cancelado",
    icon: <HiXCircle className="text-red-500" />,
    color: "bg-red-100",
  },
  ERROR: {
    label: "Erro",
    icon: <HiExclamationCircle className="text-red-500" />,
    color: "bg-yellow-100",
  },
};

const ModalCVLogs = ({ isOpen, setOpen, logs }) => {
  return (
    <Modal show={isOpen} onClose={() => setOpen(false)} size="xl">
      <ModalHeader>Histórico de Ações</ModalHeader>
      <ModalBody>
        {logs?.length > 0 ? (
          <ol className="relative border-l border-gray-200 dark:border-gray-700 ml-2">
            {logs.map((log, idx) => {
              const action = actionLabels[log.action] || {
                label: log.action,
                icon: <HiClock className="text-gray-400" />,
                color: "bg-gray-100",
              };

              return (
                <li key={idx} className="mb-3 ml-6">
                  <span className="absolute flex items-center justify-center w-4 h-4 bg-white rounded-full -left-2 ring-4 ring-white dark:ring-gray-800 mt-3">
                    {action.icon}
                  </span>
                  <div className="px-3 py-2 rounded-lg border border-gray-200 shadow-sm bg-white">
                    <div className="flex justify-between items-center mb-1">
                      <h3 className="text-sm font-semibold text-gray-800">
                        {action.label}
                      </h3>
                      <time className="text-xs font-normal text-gray-500">
                        {moment(log.createdAt).format("DD/MM/YYYY | HH:mm")}h
                      </time>
                    </div>
                    <p className="text-sm text-gray-700 mb-1">
                      {log.description}
                    </p>
                    <p className="text-xs italic text-gray-500">
                      {log.User?.name || "Sistema"}
                    </p>
                  </div>
                </li>
              );
            })}
          </ol>
        ) : (
          <p className="text-center text-sm text-gray-600">
            Nenhuma ação registrada.
          </p>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ModalCVLogs;
